import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  safetyMeasuresArr: []
}

const safetyMeasures = createSlice({
  name: 'safetyMeasures',
  initialState,
  reducers: {
    setSafetyMeasures(state, action) {
      const { name, id, mode, isMeasureImplemented } = action.payload
      let updatedMeasure = null
      if (state.safetyMeasuresArr.length > 0) {
        updatedMeasure = state.safetyMeasuresArr.find(
          (measure) => measure.name === name
        )
      }

      if (updatedMeasure) {
        state.safetyMeasuresArr = [
          ...state.safetyMeasuresArr.filter((measure) => measure.name !== name),
          {
            name,
            id,
            mode,
            isMeasureImplemented
          }
        ]
      } else {
        state.safetyMeasuresArr.push({
          name,
          id,
          mode,
          isMeasureImplemented
        })
      }
    }
  }
})

export const { setSafetyMeasures } = safetyMeasures.actions
export default safetyMeasures.reducer
